<template>
  <div class="tw-flex tw-justify-center tw-items-center">
    <div
      class="tw-animate-spin tw-rounded-full tw-border-2 tw-border-r-transparent"
      :class="borderClass"
      :style="{ width: `${size}px`, height: `${size}px` }"
    ></div>
  </div>
</template>

<script>
import fp from 'lodash/fp'

const COLOR_BORDER_CLASSES = {
  primary: 'tw-border-primary',
  secondary: 'tw-border-secondary',
  green: 'tw-border-[#23d160]',
}

export default {
  props: {
    size: {
      type: Number,
      required: false,
      default: 16,
    },
    color: {
      type: String,
      required: false,
      default: 'primary',
      validator: fp.contains(fp.__, ['primary', 'secondary', 'green']),
    },
  },
  computed: {
    borderClass() {
      return COLOR_BORDER_CLASSES[this.color]
    },
  },
}
</script>

<style></style>
